import { supabaseClient } from 'supabase'
import { requireDecided } from './deskDecisionError'

export type ApproveCandidateParams = {
  id: number
  /**
   * The fields Dominique changed before approving. Sent exactly as given;
   * `[]` means "approved untouched" and is recorded as such (DESK-07, D-09).
   */
  editedFields: string[]
}

/**
 * Mark a candidate approved and record which fields were edited
 * (`desk_approve`, D-09). The RPC stamps who decided and when; the client
 * never sends either.
 *
 * Errors are thrown raw (23514 / 22023 for a bad field list included); a
 * `false` result throws DeskAlreadyDecidedError (D-11).
 */
export const approveCandidate = async ({
  id,
  editedFields
}: ApproveCandidateParams): Promise<true> => {
  const { data, error } = await supabaseClient.rpc('desk_approve', {
    p_id: id,
    p_edited_fields: editedFields
  })

  if (error) {
    throw error
  }
  return requireDecided('desk_approve', data)
}
